<template>
  <div class="site-setup-home-content">
    <Banner type="secondary">
      <h1>ProBot's worked his magic</h1>
      <h2>Home page content</h2>
    </Banner>

    <div v-if="isLanding">
      <ProBotSvg class="robot-image" />

      <p class="content-intro">
        <span v-if="continueBtnLoading">
          <strong>ProBot</strong> is now loading your website..
        </span>

        <span v-else>
          Congratulations! Your website has been successfully created!
        </span>
      </p>

      <ProBotChat
        :text="loadingText"
        buttonText="Continue"
        :btnLoading="continueBtnLoading"
        :link="loadFirstItem"
      />
    </div>

    <div v-else>
      <div v-if="currentListItem" class="current-item">
        <div
          class="feature-block-image"
          :style="itemImage(currentListItem)"
        ></div>

        <div class="item-content">
          <transition name="fade" mode="out-in">
            <router-view
              :key="_uid"
              :listItem="currentListItem"
              :totalItems="totalItems"
            />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {readCompanySitePagesData} from '@/lib/pages'
import {readCompanySitePageListsData} from '@/lib/lists'

import {readCompanySitePageListListItemsData} from '@/lib/list_items'

import {readListTypesData} from '@/lib/list_types'

import parseComponent from '@/mixins/parseComponent'

import Banner from '@/components/Banner'
import ProBotSvg from '@/components/SiteSetup/ProBotSvg'
import ProBotChat from '@/components/SiteSetup/ProBotChat'

export default {
  name: 'homeContent',

  mixins: [parseComponent],

  components: {
    Banner,
    ProBotSvg,
    ProBotChat
  },

  data() {
    return {
      listTypes: [],
      continueBtnLoading: true,
      pages: [],
      homePage: {},
      homePageBlocks: [],
      homePageListId: ''
    }
  },

  props: ['companyId', 'siteId', 'index'],

  computed: {
    featureBlocks() {
      return this.listTypes.find((type) => type.name === 'feature-blocks')
    },

    loadingText() {
      if (this.continueBtnLoading) {
        return [
          'One moment, just fetching your new website...'
        ]
      } else {
        return 'Finished! Hit that continue button to proceed.'
      }
    },

    currentListItem() {
      let index = parseInt(this.index)
      return !this.continueBtnLoading ? this.homePageBlocks[index - 1] : {}
    },

    notFirstItem() {
      return parseInt(this.index) !== 1
    },

    itemImage() {
      return (image) => {
        return image.image_versions
          ? `background-image: url('${image.image_versions[3].url}')`
          : ''
      }
    },

    itemClass() {
      return (index) => {
        return index + 1 <= parseInt(this.index) ? 'is-active' : false
      }
    },

    totalItems() {
      return this.homePageBlocks.length
    },

    isLanding() {
      return this.$route.meta.isLanding
    },

    loadFirstItem() {
      let firstItem = this.homePageBlocks[0] || false

      return {
        name: 'showHomeContent',
        params: {
          companyId: this.companyId,
          siteId: this.siteId,
          pageId: this.homePage.id,
          listId: this.homePageListId,
          index: 1,
          listItemId: firstItem.id
        }
      }
    }
  },

  methods: {
    getData() {
      this.getListTypes()
      this.getSitePages()
    },

    getListTypes() {
      readListTypesData().then(({data}) => {
        this.listTypes = data
      })
    },

    getSitePages() {
      readCompanySitePagesData(this.companyId, this.siteId, {
        page: 1,
        page_size: 250
      }).then(({data, page}) => {
        this.homePage = data.find((page) => page.name === 'Home')
        this.getPageLists()
      })
    },

    getPageLists() {
      readCompanySitePageListsData(
        this.companyId,
        this.siteId,
        this.homePage.id
      ).then(({data}) => {
        let featureBlockId = data.find(
          (list) => list.list_type_id === this.featureBlocks.id
        ).id
        this.homePageListId = featureBlockId

        this.getPageListListItems(featureBlockId)
      })
    },

    getPageListListItems(featureBlockId) {
      readCompanySitePageListListItemsData(
        this.companyId,
        this.siteId,
        this.homePage.id,
        featureBlockId
      ).then(({data}) => {
        this.homePageBlocks = data
        this.continueBtnLoading = false
      })
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/animations'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.site-setup-home-content

.robot-image
  max-width: 300px
  margin: $gap-large auto 0
  display: block

.current-item
  background: #fff
  box-shadow: $box-shadow
  margin: 100px auto $gap-x-large
  padding: $gap-x-large $gap-medium
  max-width: 700px
  border-radius: 10px
  position: relative

  .item-content
    flex: 1

  .item-heading
    text-align: center

.feature-block-image
  background: #fff
  position: absolute
  left: 50%
  margin-top: -115px
  transform: translateX(-50%)
  width: 100px
  height: 100px
  border-radius: 50%
  background-size: cover
  background-position: center
  position: relative
  overflow: hidden
  box-shadow: $box-shadow
  z-index: 50
</style>
